export const formatPhone = (ph: string) => {
  const phone = ph || "";
  // if 10 digits
  if (phone.length === 10) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  }
  // only for US numbers
  if (phone.length === 11 && phone.startsWith("1")) {
    return `+${phone.slice(0, 1)} (${phone.slice(1, 4)}) ${phone.slice(
      4,
      7
    )}-${phone.slice(7)}`;
  }

  return phone;
};
